"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "forgotPasswordCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $http,
      $filter,
      $localStorage,
      Auth,
      MessageService,
      settings,
      apiSettings
    ) {
      var vm = this;

      var $translate = $filter("translate");

      $rootScope.laddaLoading = false;

      vm.projectModule = config.projectModule;

      switch (vm.projectModule) {
        case 'SWFlow':
          $(".auth-img").prepend(
            '<img src="/images/logo-sherwin-williams-swflow.png" alt="SWFLOW" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-powered.svg" alt="Powered by Astéria" />'
          );
          break;
        case 'Colors':
          $("body").addClass("a-sua-cor");
          $(".auth-img").prepend(
            '<img src="/images/logo-sw-colorsnap.png" alt="A Sua Cor" />'
          );
          $(".powered-img").prepend(
            '<img src="/Images/img-asuacor-powered.svg" alt="Powered by Astéria" />'
          );
          break;
      }

      vm.sendEmail = function () {
        if (!vm.model || !vm.model.email) {
          vm.auth_error =
            "Preencha o email para solicitar a recuperação de senha!";
          return;
        }

        $rootScope.laddaLoading = true;

        $http
          .post(apiSettings.baseUri + "v1/auth/forgot-password", {
            email: vm.model.email,
            projectModule: vm.projectModule,
          })
          .then(
            function (response) {
              MessageService.alertInfo(response.data);

              $state.go("login");
            },
            function (response) {
              vm.auth_error = response.data;

              $rootScope.laddaLoading = false;
            }
          );
      };
    }
  );
